<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <template v-if="row.Status < 2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="edit(row)">编辑</el-button>
              </template>
              <!-- <el-button v-if="$permission.canReview()" type="text" @click.stop="review(row.DocId)">
                <span>审核</span>
              </el-button> -->
            </template>
            <el-button type="text" v-else @click.stop="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <div v-loading="isLoading">
      <template v-if="data.InvoiceTypeId != null">
        <edit-list2 v-if="data.InvoiceTypeName == '收据'" ref="editList" is-detail :can-price="canPrice"/>
        <edit-list1 v-else ref="editList" is-detail  :can-price="canPrice"/>
      </template>
      <div class="row-tb-head" style="margin-top: 10px;">
        <span>收款信息</span>
      </div>
      <el-table border class="tb-c-head" :data="data.RpCostDocPayDtos">
        <el-table-column prop="SettleName" label="结算方式" min-width="110" />
        <el-table-column prop="AccountName" label="付款账号" />
        <el-table-column prop="PayAmount" label="付款金额" v-if="canPrice">
          <template slot-scope="{row}">
            {{row.PayAmount.toLocaleString()}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/cost/list";
import editDialog from "@/components/finance/dealings/cost/editDialog";
import detailsDialog from "@/components/finance/dealings/cost/detailsDialog";
import editList1 from "@/components/finance/dealings/cost/editList1";
import editList2 from "@/components/finance/dealings/cost/editList2";

export default {
  name: "cost",
  mixins: [curdMixins],
  components: {
    list,
    editList1,
    editList2,
    editDialog,
    detailsDialog,
  },
  data() {
    return {
      api: require("@/api/rp/costDoc").default,
      isLoading: false,
      data: {
        InvoiceTypeId: null,
        InvoiceTypeName: "",
        RpCostDocPayDtos: [],
      },
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice();
    },
  },
  methods: {
    create() {
      this.$router.push({ name: 'editCost', params: { mode: 'create' } })
    },
    edit(data) {
      this.$router.push({ name: 'editCost', params: { mode: 'edit', data } })
    },
    editById(id) {
      this.$router.push({ name: 'editCost', params: { mode: 'editById', rowId: id } })
    },
    details(data) {
      this.$router.push({ name: 'editCost', params: { mode: 'details', data } })
    },
    review(id) {
      this.$router.push({ name: 'editCost', params: { mode: 'review', rowId: id } })
    },
    reload() {
      this.$refs.list.reload();
      if (this.$refs.editList) this.$refs.editList.clear();
      this.data.InvoiceTypeId = null;
      this.data.InvoiceTypeName = "";
      this.data.RpCostDocPayDtos = [];
    },
    onChange(row) {
      console.log("选中行", JSON.parse(JSON.stringify(row)));
      this.data.RpCostDocPayDtos = [];
      this.isLoading = true;
      this.api.info(row.DocId).then((res) => {
        this.isLoading = false;
        if (res.Data) {
          this.data.InvoiceTypeId = res.Data.InvoiceTypeId;
          this.data.InvoiceTypeName = res.Data.InvoiceTypeName;
          this.$nextTick(() => {
            this.$refs.editList.setData(res.Data.RpCostDocDtsDtos);
          });
          this.data.RpCostDocPayDtos = res.Data.RpCostDocPayDtos;
        }
      });
    },
    // details(id) {
    //   this.$refs.detailsDialog.openDetailsById(id);
    // },
    // review(id) {
    //   this.$refs.detailsDialog.openEditById(id);
    // },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DocId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>